/**
 * @generated SignedSource<<8033b92a1539abdaa7787e2f039a1e89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChangePlanErrorType = "GENERIC" | "PAYMENT";
export type upgradeDialogMutation$variables = {
  planId: number;
};
export type upgradeDialogMutation$data = {
  readonly changePlan: {
    readonly errorType: ChangePlanErrorType | null;
    readonly isSuccessful: boolean;
    readonly newPlanName: string | null;
  };
};
export type upgradeDialogMutation = {
  response: upgradeDialogMutation$data;
  variables: upgradeDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "planId",
        "variableName": "planId"
      }
    ],
    "concreteType": "ChangePlanResult",
    "kind": "LinkedField",
    "name": "changePlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newPlanName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSuccessful",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "upgradeDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "upgradeDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0031d760caffd8f8436b638f1154fc8",
    "id": null,
    "metadata": {},
    "name": "upgradeDialogMutation",
    "operationKind": "mutation",
    "text": "mutation upgradeDialogMutation(\n  $planId: Long!\n) {\n  changePlan(planId: $planId) {\n    newPlanName\n    errorType\n    isSuccessful\n  }\n}\n"
  }
};
})();

(node as any).hash = "12b0e10235760ae927b0ba29e50eb071";

export default node;
